import {useEffect, useRef} from 'react';
import {consumer} from '../../../helpers/consumer';

export default function useChannel(setProcessing, processing, datagrid_id) {
  const subscription = useRef(null);

  useEffect(() => {
    if (!datagrid_id) return;

    subscription.current = consumer.subscriptions.create(
      { channel: "DatagridBulkActionChannel", datagrid_id },
      {
        received(data) {
          if (data.status) {
            setProcessing(data);

            if (data.notification_msg && data.status == 'not_processing') {
              window.ToastNotification({message: data.notification_msg, horizontal: 'center', vertical: 'top'})
            }
          }
        }
      }
    );

    return () => {
      if (subscription.current) {
        consumer.subscriptions.remove(subscription.current);
        subscription.current = null;
      }
    };
  }, [datagrid_id]);
}
